import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import useSnackbar from "../../hooks/useSnackbar";
import AgGridPaginatedTable from "../../components/AgGridPaginatedTable";
import {
  Box,
  Grid,
  Typography,
  Button,
  TextField,
  Paper,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import { useState } from "react";
import useErrorHandler from "../../hooks/useErrorHandler";
import {
  getDownloadDocument,
  getFileCabinet,
  getFilteredFile,
} from "../../api/file-cabinet";
import { useNavigate, useParams } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";
import { ViewAgenda } from "@mui/icons-material";
import { formatFileSize } from "../../config/grid-value-formatters";

export default function FileCabinet() {
  //const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [downloadInProgress, setDownloadInProgress] = useState(false);
  const [percentComplete, setPercentComplete] = useState(0);
  const dialogAction = useSelector((state) => state.dialog);
  const dispatch = useDispatch();
  const snackbar = useSnackbar();
  const errorHandler = useErrorHandler();
  const { data: user } = useSelector((state) => state.user);
  const [isFilename, setIsFilename] = useState(false);
  const [folderName, setFolderName] = useState("");
  const [globalSearch, setGlobalSearch] = useState("");
  const [tableRefreshCount, setTableRefreshCount] = useState(0);
  const navigate = useNavigate();

  function refreshTable() {
    setTableRefreshCount((prev) => prev + 1);
  }

  async function getFileCabinetTableData(limit, offset) {
    setIsFilename(true);
    try {
      const { data } = await getFileCabinet(user.token, {
        file_name: folderName,
        limit,
        offset,
      });

      return { rows: data.data, total: data.total, error: false };
    } catch (error) {
      snackbar.showError(error);
      errorHandler(error);
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }

  async function getFilteredFileCabinetTableData(limit, offset) {
    setIsFilename(false);
    try {
      const { data } = await getFilteredFile(user.token, {
        filename: globalSearch,
        limit,
        offset,
      });

      return { rows: data.data, total: data.total, error: false };
    } catch (error) {
      snackbar.showError(error);
      errorHandler(error);
      return { error: true };
    } finally {
      // setLoading(false)
    }
  }
  useEffect(() => {
    refreshTable();
  }, [folderName]);
  useEffect(() => {
    if (!globalSearch) {
      refreshTable();
    }
    return;
  }, [globalSearch]);
  // const getDownloadDocumentById = (filename) => {
  //   const encodedFilename = encodeURIComponent(filename);
  //   // console.log("filename'''''", filename);
  //   getDownloadDocument(user?.token, {
  //     folderpath: "",
  //     filename: encodedFilename,
  //   })
  //     .then((blob) => {
  //       const link = document.createElement("a");
  //       link.href = URL.createObjectURL(blob.data);
  //       link.setAttribute("download", `${filename.replace(".html",".pdf")}`);
  //       document.body.appendChild(link);
  //       link.click();
  //     })
  //     .catch((err) => {
  //       errorHandler(err);
  //     });
  // };
  const getDownloadDocumentById = (filename, filepath) => {
    setPercentComplete(0);
    const encodedFilename = encodeURIComponent(filename);
    const encodedFilepath = encodeURIComponent(filepath);
    const options = {
      // Defines options for request

      headers: {
        authorization: user?.token,
      },
      responseType: "blob",
      // For a file (e.g. image, audio), response should be read to Blob (default to JS object from JSON)

      onDownloadProgress: function (progressEvent) {
        const newPercentComplete = Math.floor(
          (progressEvent.loaded / progressEvent.total) * 100
        );
        setPercentComplete(newPercentComplete); // Update the percentComplete state
      },
    };
    setDownloadInProgress(true); // Start the download progress
    getDownloadDocument(user?.token, options, {
      folder_path: filepath ? encodedFilepath : encodedFilename,
      // folderpath: isFilename === true ? "" : filename,
      // filename: isFilename === true ? encodedFilename : "",
    })
      .then((blob) => {
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob.data);
        link.setAttribute("download", `${filename.replace(".html","")}.pdf`);
        document.body.appendChild(link);
        link.click();
        setDialogOpen(false);
      })
      .catch((err) => {
        errorHandler(err);
        setDownloadInProgress(false);
        setDialogOpen(false);
      })
      .finally(() => {
        setDownloadInProgress(false);
        setDialogOpen(false);
        // Download completed or errored, stop progress
      });
  };

  useEffect(() => {
    if (!dialogAction.type) return;
    switch (dialogAction.type) {
      case "DOWNLOADVIEW":
        dispatch({ type: "" });
        setDialogOpen(true);
        // console.log("test....", dialogAction.data?.filename);
        getDownloadDocumentById(
          dialogAction.data?.filename,
          dialogAction.data?.filepath
        );
        break;
      default:
        break;
    }
  }, [dialogAction]);

  const handleSearch = () => {
    setTableRefreshCount((prev) => prev + 1);
  };

  const columnsWithFilename = [
    {
      headerName: "Action",
      field: "actions",
      maxWidth: 73,
      cellRendererFramework: (params) => {
        if (params.data && params.data.isDirectory) {
          return (
            <Box>
              <Button
                className="actionIcon"
                onClick={() => {
                  console.log("filttered api call");
                  navigate(removeLeadingSlashAndSpaces(params.data.filename));
                }}
              >
                <ViewAgenda />
              </Button>
            </Box>
          );
        } else {
          return (
            <>
              <Button
                className="actionIcon"
                onClick={() => {
                  dispatch({ type: "DOWNLOADVIEW", data: params.data });
                }}
              >
                <DownloadIcon />
              </Button>
            </>
          );
        }
      },
    },
    {
      headerName: "Name",
      field: "filename",
      // cellClass: "text-capitalize",
    },
    {
      headerName: "Type",
      field: "type",
      headerClass: "justify-left",
    },
  ];

  const columnsWithFilenameAndSize = [
    {
      headerName: "Action",
      field: "actions",
      maxWidth: 73,
      cellRendererFramework: (params) => {
        if (params.data && params.data.isDirectory) {
          return (
            <Box>
              <Button
                className="actionIcon"
                onClick={() => {
                  console.log("getFilecabinet api call");
                  navigate(removeLeadingSlashAndSpaces(params.data.filename));
                }}
              >
                <ViewAgenda />
              </Button>
            </Box>
          );
        } else {
          return (
            <>
              <Button
                className="actionIcon"
                onClick={() => {
                  dispatch({ type: "DOWNLOADVIEW", data: params.data });
                }}
              >
                <DownloadIcon />
              </Button>
            </>
          );
        }
      },
    },
    {
      headerName: "Name",
      field: "filename",
      // cellClass: "text-capitalize",
    },
    {
      headerName: "Size",
      field: "size",
      headerClass: "justify-left",
      valueFormatter: formatFileSize,
    },
    {
      headerName: "Type",
      field: "type",
      headerClass: "justify-left",
    },
  ];
  return (
    <>
    <Box className="viewBox">
      <Box className="viewDetilsBox">
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        pb={2}
      >
        <Typography component="h5" fontWeight={500} className="pageHeading1">
          File Cabinet
        </Typography>
        <Grid item md={3} sm={3} xs={12}>
          <TextField
            size="small"
            label="Global Search"
            variant="outlined"
            value={globalSearch}
            onChange={(e) => {
              setFolderName("");
              setGlobalSearch(e.target.value);
            }}
          />

          <Button
            style={{ marginLeft: 2.5 }}
            onClick={handleSearch}
            size="medium"
            variant="contained"
            className="backButton"
          >
            Search
          </Button>
        </Grid>
      </Box>

      {/* <Box className="filter-box"> */}
      {/* <Grid container> */}
      {/* <Grid item md={1} sm={3} xs={12}>
          <Button size="small" type="button" id="basic-button">
            <SearchIcon /> <KeyboardArrowDownIcon />
          </Button>
        </Grid> */}
      {/* <Grid item md={3} sm={3} xs={12}> */}
      {/* <TextField
              id="outlined-basic"
              size="small"
              label="Name"
              variant="outlined"
              value={folderName}
              onChange={(e) => {
                setGlobalSearch("");
                setFolderName(e.target.value);
                // getUploadFilesTableData();
              }}
            /> */}
      {/* <Button size="small" type="button">
            Go
          </Button> */}
      {/* </Grid> */}
      {/* </Grid> */}
      {/* </Box> */}
      <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
        <DialogTitle>Download Progress</DialogTitle>
        <DialogContent>
          {downloadInProgress ? (
            <>
              <CircularProgress
                variant="determinate"
                value={percentComplete}
                size={50}
                thickness={10}
                style={{ marginLeft: "60px" }}
              />
              <>{percentComplete + "%"}</>
            </>
          ) : (
            <></>
          )}
        </DialogContent>
        {/* ... (your existing dialog actions, if any) */}
      </Dialog>
      <Paper elevation={3}>
        <AgGridPaginatedTable
          getTableRows={
            globalSearch
              ? (limit, offset) =>
                  getFilteredFileCabinetTableData(limit, offset)
              : (limit, offset) => getFileCabinetTableData(limit, offset)
          }
          columns={
            globalSearch !== ""
              ? columnsWithFilename
              : columnsWithFilenameAndSize
          }
          perPage={10}
          refreshCounter={tableRefreshCount}
        />
      </Paper>
      </Box>
     </Box> 
    </>
  );
}
function removeLeadingSlashAndSpaces(input) {
  
  if (input.startsWith("/")) {
    input = input.replace(/^\s*\//, "");
  }

  return input.replace(/#/g, "%23");
}
